import React from "react";
import "./Home.css";

function WindowCovers() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>WINDOW COVERS</h1>
            <p className="home-subtitle">
              <img
                style={{ backgroundColor: "white" }}
                className="brandImg"
                src="/windowCoverBrand.avif"
              />
              <br />Complete Window Shades Set
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1z4SsoBaiIHNq58-ONgVSb0v6zuFepMau/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          These window covers are designed to provide privacy and insulation while
          you're on the road. The complete set fits all windows and is easy to
          install and remove.
        </p>
        <p className="tealText">
          Magnetic window covers are stored on the storage shelf above the cockpit of the van.
        </p>
        <p className="tealText">
          There are 7 window covers, one for each window in the van (including the front windshield).
        </p>
        <p className="tealText">
          Make sure the black part of the cover is facing out towards the window when attaching.
        </p>
        <p className="tealText">
          The window covers will help with temperature regulation, keeping the van cool or warm.
        </p>
        <p className="tealText">
          The side window above the sink can open. Pull the little latch in the center of the window down to open the window. You have to be a bit forceful to slide the window open.
        </p>
      </div>

      <div className="movCont">
        <img src="/windowCovers.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default WindowCovers;
